import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  CandidateInterviewPlanned,
  CandidateInterviewPlannedV2,
} from "./../../../Redux/action/CandidateInterviewPlanned";
import { JobsInterviewPlannedAcceptAction } from "./../../../Redux/action/JobsInterviewPlannedAcceptAction";
import { toast } from "react-toastify";

import { FaCheck } from "react-icons/fa6";
import { MdOutlineCancel } from "react-icons/md";
import DeactivateModal from "../../Common/DeactivateMemberModal";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextareaAutosize,
} from "@mui/material";
import axios from "axios";
import { SpinLoader } from "../../Vendor/ImportCandidates";
import Pagination from "../../Common/Pagination/Pagination";
import { CandidateProfile } from "../../../Redux/action/CandidateProfileAction.js";
import { VendorProfile } from "../../../Redux/action/VendorProfileAction.js";

const baseUrl = process.env.REACT_APP_API_PATH;

const JobsInterviewPlanned = () => {
  const { userResult } = useSelector((state) => state.Auth);
  const member = useSelector((state) => state?.Profile?.result?.vendorId);
  const userInfo = useSelector(
    (state) => state?.CandidateJobPlanned?.result?.content
  );
  // const result = useSelector((state) => state.CandidateJobPlanned.result);
  const scheduleInterviews = useSelector(
    (state) => state.CandidateJobPlanned.scheduleInterviews
  );

  const totalPages = useSelector(
    (state) => state?.CandidateJobPlanned?.result?.totalPages
  );

  const candidateVendorId = localStorage.getItem("candidateVendorId");
  const candidateId = userResult?.userid;
  const [pageNumber, setPageNumber] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const [showOtherTextarea, setShowOtherTextarea] = useState(false);
  const [loading, setLoading] = useState(false);
  const [interviewId, setInterviewId] = useState("");

  // const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (candidateVendorId && candidateId) {
      dispatch(CandidateProfile(candidateId));
      dispatch(VendorProfile(candidateVendorId));
    }
  }, [candidateVendorId, candidateId, dispatch]);

  useEffect(() => {
    if (candidateId) {
      dispatch(CandidateProfile(candidateId));
      // console.log(candidateId);
      dispatch(CandidateInterviewPlannedV2({ candidateId }));
      dispatch(CandidateInterviewPlanned(candidateId, pageNumber));
    }
  }, [candidateId, pageNumber, dispatch]);

  const handlePageChange = (page) => setPageNumber(page);

  const AcceptInterview = (interviewId) => {
    const content = {
      response: "ACCEPTED",
      interviewId,
      candidateId,
    };
    dispatch(JobsInterviewPlannedAcceptAction(content)).then(() => {
      dispatch(CandidateInterviewPlannedV2({ candidateId }));
      dispatch(CandidateInterviewPlanned(candidateId, pageNumber));
    });
  };

  const handleReasonChange = (event) => {
    const value = event.target.value;
    setSelectedReason(value);
    setShowOtherTextarea(value === "other");
  };

  const handleOtherReasonChange = (event) => setOtherReason(event.target.value);

  const openModal = (e, intId) => {
    e.stopPropagation();
    setIsModalOpen(true);
    setInterviewId(intId);
  };

  const closeModal = () => setIsModalOpen(false);

  const handleSubmit = async () => {
    if (!selectedReason) return toast.error("Please select one option");
    if (selectedReason === "other" && !otherReason.trim())
      return toast.error("Please provide a reason in the 'Other' field");

    setLoading(true);
    try {
      const content = {
        response: "REJECTED",
        reason: selectedReason !== "other" ? selectedReason : otherReason,
      };

      await axios.post(
        `${baseUrl}/ebench/${interviewId}/availability`,
        content,
        {
          headers: { "Content-Type": "application/json" },
          params: {
            candidateId,
          },
        }
      );

      dispatch(CandidateInterviewPlanned(candidateId));
      toast.error("Interview Rejected");
      setSelectedReason("");
      closeModal();
    } catch (error) {
      console.error("Error occurred", error);
      toast.error(error?.response?.data?.status?.message || "Error occurred");
    } finally {
      setLoading(false);
    }
  };

  const handleCheck = (e, id) => {
    e.stopPropagation();
    AcceptInterview(id);
  };

  return (
    <div className="">
      <div>{/* <div className="searchCanHead"></div> */}</div>
      <div className="common_wrapper mt-5">
        <div className="card-header common_table_header">
          Interviews Planned
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table
              className="table-data"
              style={{
                minWidth: "1200px",
                width: "100%",
                textAlign: "center",
                fontSize: "14px",
              }}
            >
              <thead>
                <tr>
                  <th className="fw_600" scope="col">
                    Interview ID
                  </th>
                  <th className="fw_600" scope="col">
                    Company Name
                  </th>
                  <th className="fw_600" scope="col">
                    Round
                  </th>
                  <th className="fw_600" scope="col">
                    Interview Title
                  </th>
                  {/* <th className="fw_600" scope="col">
                    Designation
                  </th> */}
                  <th className="fw_600" scope="col">
                    Interview Mode
                  </th>
                  <th className="fw_600" scope="col">
                    Date
                  </th>

                  <th className="fw_600" scope="col">
                    Interview Time
                  </th>
                  {/* <th className="fw_600" scope="col">Start Time</th> */}
                  <th className="fw_600" scope="col">
                    Duration
                  </th>
                  {candidateVendorId == "null" && (
                    <th className="fw_600" scope="col">
                      Hiring Status
                    </th>
                  )}
                  {candidateVendorId == "null" && (
                    <th className="fw_600" scope="col">
                      {" "}
                      Score{" "}
                    </th>
                  )}
                  {/* <th className="fw_600" scope="col">
                    Status
                  </th> */}
                  <th className="fw_600" scope="col">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {scheduleInterviews && scheduleInterviews.length > 0 ? (
                  scheduleInterviews.map((item, i) => {
                    const formattedDate = item?.interviewDate
                      ? (() => {
                          const datePart = item.interviewDate.split(" ")[0];
                          const [year, month, day] = datePart.split("-");
                          return `${day}-${month}-${year}`;
                        })()
                      : "N/A";

                    const getStatusClass = (status, type) => {
                      if (type === "candidate") {
                        if (status === "PENDING" || status === "ONHOLD")
                          return "yellow_status";
                        if (status === "REJECT") return "red_status";
                        return "green_status";
                      } else {
                        if (status === "SCHEDULED") return "yellow_status";
                        if (status === "CANCELLED") return "red_status";
                        return "green_status";
                      }
                    };

                    const getCandidateStatusLabel = (status) => {
                      switch (status) {
                        case "SELECT":
                          return "Selected";
                        case "REJECT":
                          return "Rejected";
                        case "ONHOLD":
                          return "On Hold";
                        case "PENDING":
                          return "In Progress";
                        case "NEXT_ROUND":
                          return "Next Round";
                        default:
                          return "N/A";
                      }
                    };

                    return (
                      <tr
                        key={i}
                        // style={{ cursor: "pointer" }}
                        // onClick={() =>
                        //   navigate("/interviews_info/" + item?.interviewId)
                        // }
                      >
                        <td>{item?.interviewId}</td>
                        <td>{item?.companyName || "N/A"}</td>
                        <td>{item?.round || "N/A"}</td>
                        <td>{item?.interviewTitle || "N/A"}</td>
                        {/* <td>{item?.jobPosition || "N/A"}</td> */}
                        <td>{item?.interviewMode || "N/A"}</td>
                        <td>{formattedDate}</td>
                        <td>{item?.interviewStartTime || "NA"}</td>
                        <td>{item?.duration || "N/A"}</td>

                        {candidateVendorId === "null" && (
                          <>
                            <td>
                              <div
                                className={`w-75 m-auto ${getStatusClass(
                                  item?.candidateInterviewStatus,
                                  "candidate"
                                )}`}
                              >
                                {getCandidateStatusLabel(
                                  item?.candidateInterviewStatus
                                )}
                              </div>
                            </td>
                            <td>{item?.rating ? `${item.rating}/5` : "N/A"}</td>
                          </>
                        )}

                        {/* <td>
                            <div
                              className={`w-75 m-auto ${getStatusClass(
                                item?.interviewStatus,
                                "interview"
                              )}`}
                            >
                              {item?.interviewStatus || "N/A"}
                            </div>
                          </td> */}

                        {item?.isAccepted === "PENDING" ? (
                          <td>
                            <FaCheck
                              size={23}
                              color="#286a94"
                              className="me-3 pointer"
                              onClick={(e) => handleCheck(e, item?.interviewId)}
                            />
                            <MdOutlineCancel
                              size={23}
                              color="red"
                              className="pointer"
                              onClick={(e) => openModal(e, item?.interviewId)}
                            />
                          </td>
                        ) : (
                          <td>{item?.isAccepted || "N/A"}</td>
                        )}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan={10}
                      className="text-center py-4"
                      style={{
                        fontSize: "18px",
                        fontStyle: "italic",
                        color: "#9ca3af",
                        letterSpacing: "0.5px",
                      }}
                    >
                      No records found{" "}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <DeactivateModal
          isOpen={isModalOpen}
          onClose={closeModal}
          heading={"Reason for Rejection"}
        >
          <FormControl>
            <FormLabel id="demo-radio-buttons-group-label">Reasons</FormLabel>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              // defaultValue="female"
              name="radio-buttons-group"
              value={selectedReason}
              onChange={handleReasonChange}
            >
              <FormControlLabel
                className="mb-2"
                value="I am not available"
                control={<Radio />}
                label="I am not available"
              />

              <FormControlLabel
                className="mb-2"
                value="Better opportunities elsewhere"
                control={<Radio />}
                label="Better opportunities elsewhere"
              />

              <FormControlLabel
                className="mb-2"
                value="Lack of clarity about the role or expectations"
                control={<Radio />}
                label="Lack of clarity about the role or expectations"
              />

              <FormControlLabel
                className="mb-2"
                control={<Radio />}
                value={"other"}
                label="Others"
                //  onClick={handleOtherReason}
              />

              {showOtherTextarea && (
                <TextareaAutosize
                  value={otherReason}
                  onChange={handleOtherReasonChange}
                  placeholder="Other Reason"
                  minRows={5}
                  maxRows={5}
                />
              )}
            </RadioGroup>

            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <button
                variant="contained"
                className="common_btn"
                style={{
                  background: "#1c6597",
                  color: "#fff",
                  marginRight: "10px",
                  width: "100px",
                  height: "40px",
                }}
                onClick={handleSubmit} // Add your submit logic here
              >
                {!loading ? "Submit" : <SpinLoader />}
              </button>
              {/* <button
                                    className="btn btn-danger rounded-0"
                                    onClick={closeModal}
                                >
                                    Cancel
                                </button> */}
            </div>
          </FormControl>
        </DeactivateModal>
      </div>
      {userInfo?.length > 0 &&
        (member == null ||
          userInfo.some(
            (item) => item?.isAcceptedByCandidate === "ACCEPTED"
          )) && (
          <Pagination
            totalPages={totalPages}
            currentPage={pageNumber}
            onPageChange={handlePageChange}
          />
        )}
    </div>
  );
};

export default JobsInterviewPlanned;
